import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useEnquiryModel } from "../enquiryModel";
export default () => {
    const {
    } = useEnquiryModel();
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}